// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: false,
   //WebApiBaseUrl: "http://localhost:60773/Api",


   //   WebApiBaseUrl: "http://83.147.38.231:1420/Api", //testing
     WebApiBaseUrl: "https://api.test.primedairysoft.com/Api" //testing https

     //     WebApiBaseUrl: "http://83.147.38.231:4010/Api", //prod
    //  WebApiBaseUrl:"https://apiprod.primedairysoft.com/Api" //prod https
};
